export const FailedAuthLinkMessage = () => {
  return (
    <>
      Oops! It looks like something went wrong. Please go back and resend the one-time login link.
    </>
  );
};

export default FailedAuthLinkMessage;
